import React, { useReducer } from 'react';
import orderProcessService from '../services/orderProcess';

interface Props {
  children: any
}

const FormDataContext = React.createContext(null);

const actionsConst = {
  SET_PERSONAL: 'SET_PERSONAL',
  SET_DELIVERY_INFO: 'SET_DELIVERY_INFO',
};

const initialValue = {
  personal: {
    fieldAnrede: 'Herr',
    fieldName: '',
    fieldFirstname: '',
    fieldAhvNumber: '',
    fieldDob: null,
    fieldAddress: '',
    fieldAddressNotFound: false,
    fieldStrasse: '',
    fieldNr: '',
    fieldPlz: '',
    fieldOrt: '',
    fieldLand: 'Schweiz',
    fieldPhone: '',
    fieldEmail: '',
    fieldResidenceSince: '',
    fieldResidenceTill: '',
    fieldLanguage: '',
    fieldComments: '',
  },
  deliveryInfo: {
    fieldDeliveryAddressDifferent: false,
    fieldDeliveryCompany: '',
    fieldDeliveryLastname: '',
    fieldDeliveryFirstname: '',
    fieldAddress: '',
    fieldAddressNotFound: '',
    fieldStrasse: '',
    fieldNr: '',
    fieldPlz: '',
    fieldOrt: '',
    fieldLand: 'Schweiz',
  },
};

const reducer = (state, action) => {
  const {
    type,
    payload,
  } = action;

  switch (type) {
    case actionsConst.SET_PERSONAL: {
      return {
        ...state,
        personal: payload,
      };
    }

    case actionsConst.SET_DELIVERY_INFO: {
      const { deliveryInfo } = state;
      return {
        ...state,
        deliveryInfo: {
          ...deliveryInfo,
          ...payload,
        },
      };
    }

    default:
      return state;
  }
};

const FormDataContextProvider = ({ children }: Props) => {
  const [state, dispatch] = useReducer(reducer, initialValue);

  function setPersonal(personal) {
    dispatch({
      type: actionsConst.SET_PERSONAL,
      payload: personal,
    });
  }

  function setDeliveryInfo(deliveryInfo) {
    dispatch({
      type: actionsConst.SET_DELIVERY_INFO,
      payload: deliveryInfo,
    });
  }

  function fetchFormData(documentId) {
    return orderProcessService.fetchOrderDetails(documentId)
      .then((res) => {
        if (res) {
          dispatch({
            type: actionsConst.SET_PERSONAL,
            payload: res?.formData?.personal,
          });
          dispatch({
            type: actionsConst.SET_DELIVERY_INFO,
            payload: res?.formData?.deliveryInfo,
          });
        }
        return res;
      });
  }

  const contextValue = {
    state,
    setPersonal,
    setDeliveryInfo,
    fetchFormData,
    dispatch,
  };

  return (
    <FormDataContext.Provider
      value={contextValue}
    >
      { children }
    </FormDataContext.Provider>
  );
};

FormDataContextProvider.defaultProps = {
  children: '',
};

export default { FormDataContext, FormDataContextProvider, actionsConst };
